import { Link } from "react-router-dom";

const voices = [
  {
    name: "阿木",
    role: "通勤党",
    icon: "ri-user-3-fill",
    text: "早晚坐地铁全靠它打发时间，榜单更新够快，一个标题就能让我在茶水间接上同事的话题。",
    tone: "bg-primary-200 text-primary-900",
  },
  {
    name: "Momo",
    role: "追剧少女",
    icon: "ri-user-heart-fill",
    text: "分类很清楚，影视和综艺的热点不会和娱乐混在一起，按频道看特别省心，推荐给的也很准。",
    tone: "bg-secondary-200 text-secondary-900",
  },
  {
    name: "老周",
    role: "内容从业者",
    icon: "ri-user-settings-fill",
    text: "做选题最怕抓不到点，这里的热度趋势帮了大忙。关键是来源标得明明白白，用起来踏实。",
    tone: "bg-accent-200 text-accent-900",
  },
];

export default function HomeVoices() {
  return (
    <section className="container-x py-10 md:py-14">
      <div className="text-center">
        <span className="chip bg-primary-100 text-primary-800 px-3 py-1 text-xs font-bold">
          <i className="ri-heart-3-line"></i> 大家的吃瓜现场
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl">他们都在这里追新鲜事</h2>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-3">
        {voices.map((v) => (
          <figure key={v.name} className="card-surface p-5">
            <div className="flex items-center gap-3">
              <span className={`flex h-11 w-11 items-center justify-center rounded-full ${v.tone}`}>
                <i className={`${v.icon} text-lg`}></i>
              </span>
              <div>
                <figcaption className="font-bold">{v.name}</figcaption>
                <span className="text-xs text-foreground-500">{v.role}</span>
              </div>
              <i className="ri-double-quotes-r ml-auto text-2xl text-primary-200"></i>
            </div>
            <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{v.text}”</blockquote>
          </figure>
        ))}
      </div>

      <div className="relative mt-8 overflow-hidden rounded-3xl bg-gradient-to-r from-primary-600 to-secondary-500 px-6 py-10 text-center text-background-50 md:py-12">
        <i className="ri-fire-fill absolute -left-4 top-1/2 -translate-y-1/2 text-[8rem] text-background-50/10"></i>
        <i className="ri-chat-smile-line absolute -right-6 bottom-0 text-[7rem] text-background-50/10"></i>
        <h2 className="relative font-heading text-2xl md:text-3xl">别错过今天最劲爆的消息</h2>
        <p className="relative mx-auto mt-3 max-w-xl text-sm text-background-100/90">
          打开实时榜单，看看此刻全网正在吃什么瓜。每 5 分钟一次刷新，焦点动态第一时间送达。
        </p>
        <div className="relative mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/ranking" className="chip bg-accent-500 px-6 py-3 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-600">
            去看看实时榜单
          </Link>
          <Link to="/news" className="chip border border-background-50/60 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/15">
            浏览最新新鲜事
          </Link>
        </div>
      </div>
    </section>
  );
}